// ─────────────────────────────────────────────
// components/Spinner.js
// Loading spinner component
// License: MIT (your original IP)
// ─────────────────────────────────────────────

import React from "react";
import { BORDER, BLUE } from "../constants";

export function Spinner() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 48 }}>
      <div style={{
        width: 28, height: 28,
        border: `3px solid ${BORDER}`,
        borderTop: `3px solid ${BLUE}`,
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }} />
      <style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style>
    </div>
  );
}

// ─────────────────────────────────────────────
// components/Toast.js
// Toast notification overlay
// License: MIT (your original IP)
// ─────────────────────────────────────────────

export function Toast({ msg }) {
  if (!msg) return null;
  return (
    <div style={{
      position: "fixed",
      bottom: 72,
      left: "50%",
      transform: "translateX(-50%)",
      background: "#0a1628",
      color: "#fff",
      fontWeight: 600,
      fontSize: 13,
      padding: "10px 20px",
      borderRadius: 9,
      zIndex: 500,
      whiteSpace: "nowrap",
      borderLeft: "4px solid #42a5f5",
    }}>
      {msg}
    </div>
  );
}
